import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo_krizmi from "./quaniaIcon.png";
import './css/customs/header.css';
import posthog from 'posthog-js';

function navLinkClass(active) {
  return `nav-link${active ? " nav-link--active" : ""}`;
}

function Header({ showLoginBtn = true }) {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const path = location.pathname;
  const hash = location.hash || "";

  const homeActive = path === "/" && hash !== "#cta-section";
  const learnActive = path === "/learn-quranic-arabic";
  const blogActive = path === "/blog" || path.startsWith("/blog/");
  const freeResourcesActive = path === "/free" || path === "/free50";
  const getAppActive = path === "/" && hash === "#cta-section";
  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const trackNavClick = (linkName) => {
    posthog.capture('nav_link_clicked', {
      link_name: linkName,
      timestamp: new Date().toISOString()
    });
  };
  
  return (
    <header className={`site-header ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          <div className="logo-container">
            <Link to="/" className="logo-link" onClick={() => setMenuOpen(false)}>
              <img src={logo_krizmi} alt="Qurania Logo" className="logo-image" />
              <span className="logo-text">Qurania App</span>
            </Link>
          </div>
          
          <div className="menu-toggle" onClick={toggleMenu}>
            <div className={`hamburger ${menuOpen ? 'active' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          
          <nav className={`main-nav ${menuOpen ? 'active' : ''}`}>
            <ul className="nav-list">
              <li className="nav-item">
                <Link to="/" className={navLinkClass(homeActive)} aria-current={homeActive ? "page" : undefined} onClick={() => { setMenuOpen(false); trackNavClick('Home'); }}>Home</Link>
              </li>
              <li className="nav-item">
                <Link to="/learn-quranic-arabic" className={navLinkClass(learnActive)} aria-current={learnActive ? "page" : undefined} onClick={() => { setMenuOpen(false); trackNavClick('Learn'); }}>Learn</Link>
              </li>
              <li className="nav-item">
                <Link to="/blog" className={navLinkClass(blogActive)} aria-current={blogActive ? "page" : undefined} onClick={() => { setMenuOpen(false); trackNavClick('Blog'); }}>Blog</Link>
              </li>
              <li className="nav-item">
                <Link to="/free" className={navLinkClass(freeResourcesActive)} aria-current={freeResourcesActive ? "page" : undefined} onClick={() => { setMenuOpen(false); trackNavClick('Free Resources'); }}>Free Resources</Link>
              </li>
              <li className="nav-item">
                <a href="https://www.launchgood.com/v4/campaign/help_1_million_muslims_understand_the_quran_support_qurania_app" target="_blank" rel="noopener noreferrer" className="nav-link donate-link" onClick={() => { setMenuOpen(false); trackNavClick('Donate Us'); }}>Donate Us</a>
              </li>
              {showLoginBtn && (
                <li className="nav-item">
                  <Link to="/#cta-section" className={`${navLinkClass(getAppActive)} cta-button`} aria-current={getAppActive ? "page" : undefined} onClick={() => { setMenuOpen(false); trackNavClick('Get App'); }}>Get App</Link>
                </li>
              )}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );

}

export default Header;
